import { cn } from '../../lib/utils'
import { User } from 'lucide-react'

function UserIcon({ className }: { className?: string }) {
  return (
    <div className="w-[31px] h-[31px] border border-card-border rounded-md bg-gray-200 flex items-center justify-center">
      <User className={cn('h-4 w-4', className)} />
    </div>
  )
}

export { UserIcon }
